export enum PlannerBoardCardType {
    LEG = 'LEG',
    COVER = 'COVER',
    ACTIVITY = 'ACTIVITY',
    BLOCKER = 'BLOCKER',
    COVERING = 'COVERING'
}
